type WhitelistItem = {
    id: string;
    pattern: string; // patrón exacto como string (para compararlo con lo que llega de BD)
    flags?: string; // si aplica
};

function canonicalFlags(flags?: string): string {
    if (!flags) return '';
    const allowed = flags.match(/[gimsuy]/g) || [];
    return Array.from(new Set(allowed)).sort().join('');
}

function canonicalKey(pattern: string, flags?: string): string {
    return `${pattern.trim()}::${canonicalFlags(flags)}`;
}

const RE_LETTERS_ES = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s.]+$/;

const RE_POSTAL_CODE_MX = /^[0-9]{5}$/;

const RE_EMAIL_SIMPLE = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;

const RE_DIGITS_ONLY = /^\d+$/;

const PHONE_SIMPLE = /^\d{10}$/;

const RE_URL_HTTP_HTTPS =
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;

const RE_RFC_MX =
    /^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

const RE_CURP_MX =
    /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/;

const RAW_WHITELIST: WhitelistItem[] = [
    {id: 'letters_es', pattern: '^[a-zA-ZáéíóúÁÉÍÓÚñÑ\\s.]+$'},
    {id: 'postal_code_mx', pattern: '^[0-9]{5,5}$'},
    {id: 'email_simple', pattern: '^[^@]+@[^@]+.[a-zA-Z]{2,}$'},
    {id: 'digits_only', pattern: '^\\d+$'},
    {id: 'phone_simple', pattern: '^\\d{10}$'},
    {
        id: 'url_http_https',
        pattern:
            '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
        flags: 'i',
    },
    {
        id: 'rfc_mx',
        pattern:
            '^([A-ZÑ&]{4}) ?(?:- ?)?(\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01])) ?(?:- ?)?([A-Z\\d]{2})([A\\d])$',
    },
    {
        id: 'curp_mx',
        pattern:
            '^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$',
    },
];

const LITERAL_BY_ID: Record<string, RegExp> = {
    letters_es: RE_LETTERS_ES,
    postal_code_mx: RE_POSTAL_CODE_MX,
    email_simple: RE_EMAIL_SIMPLE,
    digits_only: RE_DIGITS_ONLY,
    url_http_https: RE_URL_HTTP_HTTPS,
    rfc_mx: RE_RFC_MX,
    curp_mx: RE_CURP_MX,
    phone_simple: PHONE_SIMPLE,
};

const WHITELIST_MAP = new Map<string, RegExp>(
    RAW_WHITELIST.map((w) => [canonicalKey(w.pattern, w.flags), LITERAL_BY_ID[w.id]])
);

export function isWhitelistedPattern(pattern: string, flags?: string): boolean {
    return WHITELIST_MAP.has(canonicalKey(pattern, flags));
}

export function getWhitelistedRegex(pattern: string, flags?: string): RegExp | null {
    return WHITELIST_MAP.get(canonicalKey(pattern, flags)) ?? null;
}
